import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const ClientsModule = lazy(loadModule);

export default ClientsModule;
